export default "__VITE_ASSET__B4F34kF0__"